import { Link, useLocation } from 'react-router-dom';
import { Home, ShoppingBag, Wallet, User, ShoppingCart, Gift, MessageCircle } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { useCart } from '../context/CartContext';

export default function BottomNav() {
  const { user } = useAuth();
  const { cartCount } = useCart();
  const { pathname } = useLocation();

  const tabs = [
    { to: '/', icon: Home, label: 'Home' },
    { to: '/orders', icon: ShoppingBag, label: 'Orders' },
    { to: '/cart', icon: ShoppingCart, label: 'Cart', badge: cartCount },
    { to: '/rewards', icon: Gift, label: 'Rewards' },
    { to: user ? '/profile' : '/login', icon: User, label: user ? 'Me' : 'Login' },
  ];

  return (
    <div className="bottom-nav md:hidden">
      <div className="flex">
        {tabs.map(({ to, icon: Icon, label, badge }) => {
          const active = pathname === to;
          return (
            <Link key={to} to={to}
              className="flex-1 flex flex-col items-center py-2 gap-0.5 transition-colors relative"
              style={{ color: active ? '#FF6B00' : '#6B6B8A' }}>
              <div className="relative">
                <Icon size={20} strokeWidth={active ? 2.5 : 1.5} />
                {badge > 0 && (
                  <span className="absolute -top-1.5 -right-1.5 w-4 h-4 rounded-full text-white flex items-center justify-center font-bold"
                    style={{ background: '#FF6B00', fontSize: '9px' }}>
                    {badge > 9 ? '9+' : badge}
                  </span>
                )}
              </div>
              <span className="text-xs font-medium" style={{ fontFamily: 'DM Sans' }}>{label}</span>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
